export default "__VITE_ASSET__bd5f8e02__"